import { useState, useCallback } from "react";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";

export default function useRPTForecast() {
  const [forecastResult, setForecastResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const validateInputs = ({ origin, destination, truckType, startDate }) => {
    if (!origin?.full) return "Origin is required.";
    if (!destination?.full) return "Destination is required.";
    if (!truckType?.raw_truck_name) return "Truck type is required.";

    const dims = truckType.user_dimensions || {};
    if (
      !dims.capacity_mt ||
      !dims.length_ft ||
      !dims.axle_type ||
      !dims.no_of_wheels ||
      !dims.body_type
    ) {
      return "Complete truck dimensions are required.";
    }

    if (!startDate || isNaN(startDate.getTime())) {
      return "Valid date is required.";
    }

    return null; // no errors
  };

  const handleForecast = useCallback(
    async ({ origin, destination, truckType, startDate }) => {
      const validationError = validateInputs({
        origin,
        destination,
        truckType,
        startDate,
      });

      if (validationError) {
        // if this if block is executed it
        // means your code or structure is wrong
        setError(validationError);
        setForecastResult(null);
        console.log(validationError, "error");
        return;
      }

      setIsLoading(true);
      setError(null);
      setForecastResult(null);

      const payload = {
        origin: origin.full,
        destination: destination.full,
        truck: {
          truck_type: truckType.raw_truck_name,
          no_of_wheels: truckType.user_dimensions.no_of_wheels,
          capacity_mt: truckType.user_dimensions.capacity_mt,
          length_ft: truckType.user_dimensions.length_ft,
          axle_type: truckType.user_dimensions.axle_type,
          body_type: truckType.user_dimensions.body_type,
        },
        date: `${startDate.getFullYear()}-${startDate.getMonth() + 1
          }-${startDate.getDate()}`,
      };

      try {
        const response = await axios.post(`${Urls.rpt_base_url}/predict`, payload);
        if (response.status === 200) {
          setForecastResult(response.data);
        } else {
          setError("Unexpected response from server.");
        }
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong.";
        setError(message);
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const getHeaderMapping = async (headers, sampleRows) => {
    try {
      const { data } = await axios.post(`${Urls.rpt_base_url}/auto_match_headers`, {
        headers,
        sample_rows: sampleRows,
      });


      if (data?.missing_fields?.length > 0 || data?.error) {
        const errorMsg =
          `Some required fields are missing: ${data.missing_fields.join(", ")}`;
        return { mapping: null, error: errorMsg };
      }

      return { mapping: data.mapping, error: null };
    } catch (error) {
      console.error("Error fetching header mapping:", error);
      const fallback =
        error?.response?.data?.error ||
        "Header mapping failed. Please check the file format.";
      return { mapping: null, error: fallback };
    }
  };

  return {
    forecastResult,
    isLoading,
    error,
    handleForecast,
    getHeaderMapping,
  };
}
